import React from 'react';
import { Link } from 'react-router';
import { useBrand } from '../../../app/config/brand';
import { Card } from '../../../shared/components/ui/Card';
import { PageTitle } from '../../../shared/components/ui/PageTitle';
import { SectionTitle } from '../../../shared/components/ui/SectionTitle';
import { useMcpConfig } from '../../integrations/hooks/useMcpConfig';

const CustomerSettings: React.FC = () => {
  const brand = useBrand();
  const { enabled: mcpEnabled } = useMcpConfig();
  return (
    <div className="space-y-4">
      <PageTitle subtitle="Manage your account preferences">Settings</PageTitle>
      <Card>
        <SectionTitle>Account Settings</SectionTitle>
        <p className="text-sm" style={{ color: brand.colors.textLight }}>
          Account settings and preferences will be available here.
        </p>
      </Card>
      <Link to="/settings/payment-methods" className="block">
        <Card className="transition-shadow hover:shadow-md">
          <div className="flex items-center justify-between">
            <div>
              <SectionTitle>Payment Methods</SectionTitle>
              <p className="text-sm" style={{ color: brand.colors.textLight }}>
                Add or remove cards and set a default payment method.
              </p>
            </div>
            <span aria-hidden className="text-xl" style={{ color: brand.colors.link }}>&rarr;</span>
          </div>
        </Card>
      </Link>
      {mcpEnabled && (
        <Link to="/settings/integrations" className="block">
          <Card className="transition-shadow hover:shadow-md">
            <div className="flex items-center justify-between">
              <div>
                <SectionTitle>Integrations</SectionTitle>
                <p className="text-sm" style={{ color: brand.colors.textLight }}>
                  Connect a Claude client to prepare and review your filings.
                </p>
              </div>
              <span aria-hidden className="text-xl" style={{ color: brand.colors.link }}>&rarr;</span>
            </div>
          </Card>
        </Link>
      )}
    </div>
  );
};

export default CustomerSettings;
